/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierIssueType } from "./CarrierIssueType";
import {
  CarrierIssueTypeFromJSON,
  CarrierIssueTypeFromJSONTyped,
  CarrierIssueTypeToJSON,
  CarrierIssueTypeToJSONTyped,
} from "./CarrierIssueType";

/**
 *
 * @export
 * @interface ShipmentSummary
 */
export interface ShipmentSummary {
  /**
   *
   * @type {string}
   * @memberof ShipmentSummary
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentSummary
   */
  proNumber?: string;
  /**
   * The reference on the driver's paperwork. Carriers search the list by
   * it as often as by PRO, so the summary carries it.
   *
   * @type {string}
   * @memberof ShipmentSummary
   */
  billOfLadingNumber?: string;
  /**
   * Pre-formatted "City, PROV" for the pickup.
   * @type {string}
   * @memberof ShipmentSummary
   */
  pickup: string;
  /**
   * Business name at pickup. Shown to the carrier because they
   * physically collected there and it is on the bill of lading, so it
   * is not a new disclosure.
   *
   * @type {string}
   * @memberof ShipmentSummary
   */
  pickupName?: string;
  /**
   * ISO country code for the pickup, for the flag.
   * @type {string}
   * @memberof ShipmentSummary
   */
  pickupCountry?: string;
  /**
   * Pre-formatted "City, PROV" for the delivery.
   * @type {string}
   * @memberof ShipmentSummary
   */
  delivery: string;
  /**
   * Business name at delivery. See pickupName.
   * @type {string}
   * @memberof ShipmentSummary
   */
  deliveryName?: string;
  /**
   * ISO country code for the delivery, for the flag.
   * @type {string}
   * @memberof ShipmentSummary
   */
  deliveryCountry?: string;
  /**
   * Pre-formatted scheduled pickup date.
   * @type {string}
   * @memberof ShipmentSummary
   */
  pickupDate?: string;
  /**
   * Pre-formatted actual delivery date, once delivered.
   * @type {string}
   * @memberof ShipmentSummary
   */
  deliveryDate?: string;
  /**
   * Raw shipment state name; the frontend maps it to a label.
   * @type {string}
   * @memberof ShipmentSummary
   */
  state: string;
  /**
   *
   * @type {string}
   * @memberof ShipmentSummary
   */
  commodity?: string;
  /**
   * Pre-formatted handling units and weight, e.g. "14 Skid, 43,752lb".
   * Composed server-side so both apps read the same wording.
   *
   * @type {string}
   * @memberof ShipmentSummary
   */
  freightSummary?: string;
  /**
   * What this shipment costs FreightSimple (CAD): the agreed rate until
   * the carrier invoices us, then invoices less credit notes. Shown as
   * "Cost", not "Paid" — nothing has been paid on a shipment that is
   * still moving.
   *
   * @type {number}
   * @memberof ShipmentSummary
   */
  paidCad?: number;
  /**
   *
   * @type {CarrierIssueType}
   * @memberof ShipmentSummary
   */
  openIssueType?: CarrierIssueType;
}

/**
 * Check if a given object implements the ShipmentSummary interface.
 */
export function instanceOfShipmentSummary(
  value: object,
): value is ShipmentSummary {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("pickup" in value) || value["pickup"] === undefined) return false;
  if (!("delivery" in value) || value["delivery"] === undefined) return false;
  if (!("state" in value) || value["state"] === undefined) return false;
  return true;
}

export function ShipmentSummaryFromJSON(json: any): ShipmentSummary {
  return ShipmentSummaryFromJSONTyped(json, false);
}

export function ShipmentSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentSummary {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    proNumber: json["proNumber"] == null ? undefined : json["proNumber"],
    billOfLadingNumber:
      json["billOfLadingNumber"] == null
        ? undefined
        : json["billOfLadingNumber"],
    pickup: json["pickup"],
    pickupName: json["pickupName"] == null ? undefined : json["pickupName"],
    pickupCountry:
      json["pickupCountry"] == null ? undefined : json["pickupCountry"],
    delivery: json["delivery"],
    deliveryName:
      json["deliveryName"] == null ? undefined : json["deliveryName"],
    deliveryCountry:
      json["deliveryCountry"] == null ? undefined : json["deliveryCountry"],
    pickupDate: json["pickupDate"] == null ? undefined : json["pickupDate"],
    deliveryDate:
      json["deliveryDate"] == null ? undefined : json["deliveryDate"],
    state: json["state"],
    commodity: json["commodity"] == null ? undefined : json["commodity"],
    freightSummary:
      json["freightSummary"] == null ? undefined : json["freightSummary"],
    paidCad: json["paidCad"] == null ? undefined : json["paidCad"],
    openIssueType:
      json["openIssueType"] == null
        ? undefined
        : CarrierIssueTypeFromJSON(json["openIssueType"]),
  };
}

export function ShipmentSummaryToJSON(json: any): ShipmentSummary {
  return ShipmentSummaryToJSONTyped(json, false);
}

export function ShipmentSummaryToJSONTyped(
  value?: ShipmentSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    proNumber: value["proNumber"],
    billOfLadingNumber: value["billOfLadingNumber"],
    pickup: value["pickup"],
    pickupName: value["pickupName"],
    pickupCountry: value["pickupCountry"],
    delivery: value["delivery"],
    deliveryName: value["deliveryName"],
    deliveryCountry: value["deliveryCountry"],
    pickupDate: value["pickupDate"],
    deliveryDate: value["deliveryDate"],
    state: value["state"],
    commodity: value["commodity"],
    freightSummary: value["freightSummary"],
    paidCad: value["paidCad"],
    openIssueType: CarrierIssueTypeToJSON(value["openIssueType"]),
  };
}
